import React from 'react';
import { StylovyzeDialog } from '@innovyze/stylovyze';
import { StyledWarningDialogPaper } from './ValuemappingDurationDialog.styles';
import { Typography } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';

interface ValuemappingDurationDialogProps {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export const ValuemappingDurationDialog: React.FC<
	ValuemappingDurationDialogProps
> = (props: ValuemappingDurationDialogProps) => {
	const { open, onConfirm, onCancel } = props;
	const { t } = useGlobalization();

	return (
		<StylovyzeDialog
			title={t('Considerable data reprocessing')}
			open={open}
			confirmText={t('Ok')}
			cancelText={t('Cancel')}
			onConfirm={onConfirm}
			onCancel={onCancel}>
			<StyledWarningDialogPaper>
				<Typography>
					{t(`Applying Value Mapping profiles requires considerable
						data reprocessing for large numbers of sensors. You may
						experience some delays until the updates are fully
						available in the system.`)}
				</Typography>
			</StyledWarningDialogPaper>
		</StylovyzeDialog>
	);
};

export default ValuemappingDurationDialog;
